import { render, staticRenderFns } from "./OpenDialog.vue?vue&type=template&id=39d384ea&scoped=true&"
import script from "./OpenDialog.vue?vue&type=script&lang=ts&"
export * from "./OpenDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OpenDialog.vue?vue&type=style&index=0&id=39d384ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d384ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
